import { render, staticRenderFns } from "./TitleAndExplanation.vue?vue&type=template&id=1445d435&scoped=true"
import script from "./TitleAndExplanation.vue?vue&type=script&lang=js"
export * from "./TitleAndExplanation.vue?vue&type=script&lang=js"
import style0 from "./TitleAndExplanation.vue?vue&type=style&index=0&id=1445d435&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1445d435",
  null
  
)

export default component.exports